"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var section_swapper_1 = require("../../components/section_swapper");
var lady_watching_you_png_1 = __importDefault(require("../../assets/about_us/lady_watching_you.png"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var ServicesPage = function (props) {
    var _a = props;
    var bottomList = (0, react_1.useState)([
        {
            icon: pro_solid_svg_icons_1.faDroplet,
            title: "General Clinic Blood Pressure",
            list: [
                "Cholesterol Testing (total and HDL)",
                "Blood Glucose Test",
                "BMI - Body mass index",
                "H.Pylori Testing",
                "Peak Flow - asthma and pulmonary diseases (great screening test)",
                "Emergency Nebulizing facility",
                "Vaccines such as flu and Pneumovax for the aged and frail",
                "Phlebotomy services (insurance and at doctor's requests)",
                "School Health - supplement advice, hygiene (lice and scabies). Advice and vaccine administering such as immunoglobulin in case of measles or meningitis outbreak. DOH support. (Notifiable conditions)",
                "Basic emergency - sprains and aches, asthma follow up after doctor's visits, nebulizing facility",
                "First aid kits - choose one that's right for you.",
                "General nutrition & deficiency",
                "Chronic disease follow up and management",
            ],
        },
        {
            icon: pro_solid_svg_icons_1.faHome,
            title: "Reproductive Health Services Family planning [Selected Locations]",
            list: [
                "HIV counselling and testing",
                "STI testing and condom use Pregnancy tests and nutritional advice during pregnancy",
                "General nutrition & deficiency management",
                "STI follow-up and management (HPT, STDs, HIV etc.)",
            ],
        },
        {
            icon: pro_solid_svg_icons_1.faCarriageBaby,
            title: "Baby Clinic",
            list: [
                "Emergency nebulizing facility Baby Wellness, incl nutritional advice and FTT (failure to thrive charts) and Growth charts Scholar Health",
                "Supplement advice, Hygiene (Lice and scabies). Immunizations and additional vaccine administration such as Immunoglobulin in case of Measles or Meningitis outbreak. DOH support. (Notifiable conditions)",
                "Skills and services. Our Pharmacists are highly trained health professionals, knowledgeable about a range of medical conditions and capable of delivering some advisory, diagnostic, and treatment services.",
                "Cost. The Local Choice pharmacies operate in a highly competitive business environment and are already acting to lower the nation’s cost of prescription medications by promoting generics.",
                "Health Care services. With in-store clinics, wellness programs, health screenings, and disease management services.",
            ],
        },
    ])[0];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "right", image: lady_watching_you_png_1.default, smallTitle: "RIGHT WHERE YOU SHOP", bigTitle: "What we offer.", 
                // buttonText="Learn More"
                description: "The Local Choice Clinic delivers high-quality, convenient and affordable health consults, medical screening tests, immunizations, and physical exams. Contact your nearest branch to schedule an appointment or request a full list of services.", content: [
                    {
                        description: "The Local Choice Clinic are here for you, and to keep our patients living healthy.",
                        list: [
                            "Diabetic care and dietary advice",
                            "Blood pressure monitoring",
                            "Glucose screening",
                            "Cholesterol screening",
                            "HIV screening, testing and counselling",
                            "Weight loss advice",
                            "Vitamin injections",
                            "Medical Aid health assessments",
                            "Nebulization and inhalation",
                            "Wound care",
                            "Flu Shots",
                            "Chronic disease follow-up and management",
                        ],
                    },
                ] }),
            react_1.default.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-8 pt-24" }, bottomList.map(function (item, index) {
                return (react_1.default.createElement(doshx_controls_web_1.BoxControl, { key: index, className: "", backgroundColor: "bg-gray-200", borderColor: "border-transparent" },
                    react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement("div", { className: "text-4xl flex flex-row justify-center text-primary drop-shadow-lg" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: item.icon })),
                        react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: item.title, bold: true, size: "2xlarge", textColor: "text-black", center: true }))),
                    react_1.default.createElement("div", { className: "pt-8" }, item.list.map(function (listItem, index) {
                        return (react_1.default.createElement("div", { key: index, className: "flex flex-row gap-4" },
                            react_1.default.createElement("div", { className: "text-xl text-success" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckCircle })),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: listItem, textColor: "text-black" }))));
                    }))));
            })))));
};
exports.ServicesPage = ServicesPage;
